import React from 'react';
import styles from './course.css';
import moment from 'moment';
import defaultImg from './defaultbanner.png';

class ActiveBanner extends React.PureComponent {
    constructor(props) {
        super(props);
        this.signUp = this.signUp.bind(this);
        this.competition = this.competition.bind(this);
        this.state = {signUpStatus: moment(new Date()).unix() > moment(this.props.course.lessons[0].time).unix()}
    }

    componentDidMount() {
        const startTime = this.props.course.lessons[0].time
        if (!this.state.signUpStatus) {
            setTimeout(() => {
                this.setState({
                    signUpStatus: true
                })
            }, moment(startTime).unix() - moment(new Date()).unix())
        }
    }

    signUp(){
        const {course: {id, clazz_course},history} = this.props
        history.push(`/competition?id=${id}&clazz_id=${clazz_course.clazz_id}`);
    }

    competition(){
        const {course: {id, clazz_course, lessons},history} = this.props
        history.push(`/lesson?id=${lessons[0].id}&course_id=${id}&clazz_id=${clazz_course.clazz_id}`)
    }

    render() {
        const {course: {cover, desc, record, clazz_course}, height} = this.props
        const {signUpStatus} = this.state

        const richText = desc.replace(/<[^>]+>/g, "").replace(/&nbsp;/ig, "");
        return (
            <div className={styles.Box}>
                <div className={styles.signUpBanner} style={{height: `${height}px`}}>
                    <img src={cover ? (window.config.staticURL + '/avatar/' + cover) : defaultImg} />
                    <div className={styles.btnBox}>
                        {signUpStatus ? (
                            <button className={styles.signUpBtn} onClick={this.competition}>进入比赛</button>
                        ) : (
                            record && record.clazz_id == clazz_course.clazz_id ? (
                                <button className={styles.signUpBtnDisabled}>已报名</button>
                            ) : (
                                <button className={styles.signUpBtn} onClick={this.signUp}>报名</button>
                            )
                        )}
                    </div>
                </div>
                <div className={styles.description}>{richText}</div>
            </div>
        )
    }
}

export default ActiveBanner
